import EnglishIcon from "./../assets/svg/english.svg";
import CalendarIcon from "./../assets/svg/calendar.svg";
import CreativityIcon from "./../assets/svg/creativity.svg";
import OrderIcon from "./../assets/svg/order.svg";
import FacebookIcon from "./../assets/svg/facebook_author.svg";
import WWWIcon from "./../assets/svg/www_author.svg";
import MonikaJPG from "./../assets/img/authors/Monika.jpg";
import AniaJPG from "./../assets/img/authors/Anna.jpg";
import MarlenaJPG from "./../assets/img/authors/Marlena.jpg";
import AgnieszkaJPG from "./../assets/img/authors/Agnieszka.jpg";
import RenataJPG from "./../assets/img/authors/Renata.jpg";
import KarolinaJPG from "./../assets/img/authors/Karolina.jpg";
import one from "./../assets/img/planner_bowel/01.png";
import two from "./../assets/img/planner_bowel/02.png";
import three from "./../assets/img/planner_bowel/03.png";
import four from "./../assets/img/planner_bowel/04.png";
import five from "./../assets/img/planner_bowel/05.png";
import six from "./../assets/img/planner_bowel/06.png";
import seven from "./../assets/img/planner_bowel/07.png";
import eight from "./../assets/img/planner_bowel/08.png";

export const boxesSPANISH = [
    {
        header: "English",
        description:
            "Creada íntegramente en inglés y dirigida especialmente a los profesores de inglés",
        icon: EnglishIcon,
    },
    {
        header: "Todo el año",
        description:
            "... o incluso 13 meses, un calendario desde agosto de 2021 hasta agosto de 2022",
        icon: CalendarIcon,
    },
    {
        header: "Creatividad",
        description:
            "Ideas de actividades lingüísticas para niños de preescolar y primaria",
        icon: CreativityIcon,
    },
    {
        header: "Organización",
        description:
            "Todo en un solo lugar - agenda y planificador del trabajo del profesor",
        icon: OrderIcon,
    },
];

export const situationsSPANISH = [
    {
        header: "¿Necesitas ayuda para distribuir los temas de tus clases para cada semana?",
        description:
            "Easy! En el planificador encontrarás un horario de materiales preparado para todo el año, además hemos añadido: objetivos de las lecciones, canciones sugeridas, vocabulario y frases básicas, vocabulario y expresiones adicionales, actividades y juegos sugeridos.",
        inverted: false,
    },
    {
        header: "¿Vuelve a ser domingo y de nuevo te preguntas qué planear para sorprender a tus alumnos? ",
        description:
            "¡Abre tu agenda y aprovecha los consejos e ideas ya preparados! ¡Basta con leer y ponerse en marcha!",
        inverted: true,
    },
    {
        header: "¿De nuevo buscas unos versos infantiles interesantes? ",
        description: "Consulta la agenda, ¡seguro que los encuentras allí!",
        inverted: true,
    },
    {
        header: "¿Eres creativa, pero a veces te falta tiempo o ganas para inventar nuevos juegos?",
        description:
            "Aprovecha los juegos ya preparados, ¡hay ideas para cada semana del año en Get Creative Every Day!",
        inverted: false,
    },
    {
        header: "¿Buscas una ocasión para celebrar con tus alumnos?",
        description:
            "Cada mes encontrarás una lista de días festivos oficiales y no oficiales, ¡que serán una gran oportunidad para realizar actividades divertidas!",
        inverted: false,
    },
    {
        header: "¿Diriges varios grupos y tienes listas de información de estudiantes en varios lugares? ¿Los horarios de todos los grupos también los tienes en varios cuadernos? ¿Llevas todo esto contigocada día?",
        description:
            "Sabemos que te gustan las shopper bags, o ¿por qué ocupar espacio con material didáctico en diversos cuadernos?:) ¡Utiliza tu planificador y tendrás todo en un solo lugar!",
        inverted: true,
    },
    {
        header: "¿Utilizas dos o más agendas para guardar notas profesionales y personales?",
        description:
            "En Get Creative tendrás sitio para todo, ¡es realmente muy espaciosa!",
        inverted: false,
    },
];

export const detailsBoxesSPANISH = [
    {
        header: "School Year Calendar",
        description:
            "Planner with 13 months of monthly and weekly pages from August 2021 to August 2022",
    },
    {
        header: "Let’s plan",
        description:
            "Ready to use lesson planning spreads which cover all school year. There is some additional space for you own notes",
    },
    {
        header: "My students",
        description:
            "Useful tables to gather information about your students and groups, such as attendance, grades, homework completion and more  (10 table spreads for 10 groups of students)",
    },
    {
        header: "Contacts",
        description:
            "Your handy contact lists to organise phone numbers, addresses etc.",
    },
    {
        header: "Teaching hacks  -  tips useful in your everyday work",
        sublist: [
            { item: "5 reliable energisers for your lessons" },
            { item: "5 Various speaking incentives" },
            {
                item: "5 Mindfulness exercises which support learning a foreign language",
            },
            {
                item: "6 Beginner’s tips – useful time-savers and other tricks",
            },
            {
                item: "TOP 10 BOOKS – a list of must-have English books for children which guarantee a wow effect on your lessons",
            },
            {
                item: "TOP 5 SITES – a list od educational sites for children. Use them to make your lessons more attractive and interactive",
            },
            {
                item: "Lists of interesting English films and series for children",
            },
        ],
    },
    {
        header: "Filled-in monthly theme schedules",
        description:
            "Iincluding lesson objectives, suggested songs, basic vocabulary and expressions lists, extended vocabulary lists, suggested games and activities around the topic (60 ideas!)",
    },
    {
        header: "Nursery rhymes",
        description: "20 theme rhymes adored by young learners",
    },
    {
        header: "Creativity",
        description:
            "Games and activities suggested every week (58 ideas ready to use)",
    },
    {
        header: "Let’s celebrate",
        description:
            "Lists of official holidays, special dates and theme days every month",
    },
    {
        header: "Weekly view pages",
        description:
            "Which offer ample writing space for detailed daily planning and classroom scheduling every day of the week so you can stay organized throughout the school year",
    },
    {
        header: "Ready-to-use craft",
        description:
            "Additional pages with a calendar to cut out and colour with your children; use it to revise months or seasons of the year",
    },
    { header: "Notes", description: "Ample space for your notes" },
];

export const slidesSPANISH = [
    {
        title: "School Year Calendar",
        description:
            "calendario para el año escolar que incluye el período de agosto 2021 a agosto 2022 (calendario corto y largo con espacio para notas)",
        photo: one,
    },
    {
        title: "Let’s plan",
        description:
            "un horario preparado de temas para todo el año, con espacio para escribir tus notas",
        photo: two,
    },
    {
        title: "My students",
        description:
            "unas prácticas tablas para registrar cualquier información sobre los alumnos de cada grupo que dirijas (10 tablas para 10 grupos)",
        photo: three,
    },
    {
        title: "Teaching hacks, Nursery rhymes, Let’s celebrate",
        list: [
            {
                item: "Consejos para los profesores que serán útiles en el trabajo diario",
            },
            { item: "Hasta 20 versos temáticos" },
            {
                item: "Una lista de las fiestas oficiales y no oficiales de cada mes",
            },
        ],
        photo: four,
    },
    {
        title: "Horario preparado para cada mes con",
        description:
            "Objetivos de la lección, ejemplos de canciones, vocabulario y frases básicas, vocabulario y expresiones adicionales, ejemplos de actividades y juegos (hasta 60 actividades preparadas)",
        photo: five,
    },
    {
        title: "Organizador semanal para poder planificar eltrabajo de cada día",
        description:
            "Juegos creativos para cada semana del año (hasta 58 ideas listas para ser utilizadas al momento)",
        photo: six,
    },
    {
        title: "Notas",
        description: "Mucho espacio para tus notas",
        photo: seven,
    },
    {
        title: "Calendario-craft",
        description:
            "Una gran excusa para hablar de las estaciones del año y un estupendo juego de integración del grupo",
        photo: eight,
    },
];

export const buyHeadersSPANISH = [
    {
        header: "¿Ves?",
        description:
            "No se trata solo de una agenda y un planificador, sino simplemente de algo esencial parael profesor de inglés, ¡con valiosos materiales que utilizarás durante todo el año!",
    },
    {
        header: "¡Date prisa! ¿Por qué comprar ahora?",
        description:
            "aunque todavía falta un tiempo para el nuevo curso escolar? Nunca se sabecuándo se acabarán nuestras existencias, ni siquiera nosotros. No desperdicies tus vacaciones de verano planificando, y entra de lleno en el nuevo curso escolar. Organízate por muy poco dinero, ¡solo son 99 PLN por todo el año! Eso son 8 PLN al mes, ¡menos que un café con leche!  Únete al grupo de profesores de inglés organizados y creativos.",
    },
];

export const authorsSPANISH = [
    {
        photo: MonikaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Anna Kowalska",
            description:
                "Profesora de inglés con 18 años de experiencia en Polonia, Inglaterra e Irlanda, directora de estudios y formadora de profesores. Apoya a equipos didácticos en escuelas de idiomas, capacita a profesores y habla en conferencias y reuniones del sector. Autora del sitio web That is Evil dirigido a profesores de EFL.",
        },
    },
    {
        photo: AniaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Martyna Bornicka",
            description:
                "Profesora de inglés en jardín de infancia. Amante de los libros para niños, para quienes contar cuentos es su elemento favorito de las clases. Fundadora de Little Forest Children's Bookshop, un lugar lleno de ayudas didácticas creativas para profesores.",
        },
    },
    {
        photo: MarlenaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Cristine John",
            description:
                "Profesora de inglés durante más de 9 años. Autora del blog de inglés. Su filosofía de la educación siempre ha sido hacer que el aprendizaje sea emocionante, interesante y divertido.",
        },
    },
    {
        photo: KarolinaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Karolina Machnicka",
            description:
                "Una profesora de inglés que ama trabajar con niños. A menudo utiliza ayudas didácticas inusuales y libros en inglés en sus lecciones. Diariamente, comparte sus ideas y proporciona materiales en el blog.",
        },
    },
    {
        photo: RenataJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Renata Nowak",
            description:
                "Licenciada en Filología Inglesa, profesora con más de 10 años de experiencia. Autora del blog 'EasyPeasy' y de la guía 'Inglés sin Manual'. Consultora metodológica que apoyó la creación de un robot educativo en la Universidad Dino.",
        },
    },
    {
        photo: AgnieszkaJPG,
        links: [
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: FacebookIcon,
            },
            {
                link: "get-creative-everyday-demo.netlify.app",
                icon: WWWIcon,
            },
        ],
        author: {
            name: "Agnieszka Roland",
            description:
                "Crea juegos de idiomas que le gustaría jugar, prepara lecciones en las que le gustaría participar, enseña de la manera en que le gustaría que le enseñaran. Ayuda a otros profesores a hacer que las clases de idiomas sean más atractivas y animadas. Crea juegos originales, que comparte con gusto con profesores de varios idiomas en el sitio web. Muestra cómo utilizar la tecnología en el aula y enseña a otros a enseñar para que se diviertan en sus propias lecciones. Hace que tanto profesores como estudiantes quieran aprender.",
        },
    },
];
